module.exports = "https://cdn.thelire.com/ins/resource/ico_coinstore_rateus5star@3x.772dd64529b6c0d810b4867f3e5f88bc.png";